import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useIsMobile } from '../hooks/useIsMobile';

export default function Layout() {
  const isMobile = useIsMobile();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const openMobileMenu = () => setIsMobileMenuOpen(true);
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <div className="flex h-screen" style={{ background: 'var(--bg-base)' }}>
      {/* Desktop Sidebar - Hidden on Mobile */}
      <div className="hidden md:block">
        <Sidebar />
      </div>

      {/* Mobile Sidebar Drawer */}
      {isMobile && isMobileMenuOpen && (
        <>
          {/* Backdrop overlay */}
          <div
            className="fixed inset-0 z-40 transition-opacity"
            style={{ background: 'rgba(0,0,0,0.6)' }}
            onClick={closeMobileMenu}
          />
          {/* Sidebar drawer */}
          <div
            className="fixed left-0 top-0 h-full w-64 z-50"
            style={{
              background: 'var(--bg-surface)',
              boxShadow: '4px 0 24px rgba(0,0,0,0.3)',
            }}
          >
            <Sidebar onClose={closeMobileMenu} isMobile={true} />
          </div>
        </>
      )}

      <div className="flex-1 flex flex-col overflow-hidden">
        <Header
          isMobile={isMobile}
          onMenuClick={openMobileMenu}
        />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
